export const consequence = () => {
    return {
        company_id: null,
        title: null,
        description: null,
        severities: [
            {
                severity: 0,
                description: null
            },
            {
                severity: 1,
                description: null
            },
            {
                severity: 2,
                description: null
            },
            {
                severity: 3,
                description: null
            },
            {
                severity: 4,
                description: null
            },
            {
                severity: 5,
                description: null
            }
        ]
    }
}

export default {
    matrix: [],
    companies: [],
    consequence: consequence(),
    incremental_probabilities: [],
    loading_companies: false,
    action: 'Crear',
    filters: {
        company_id: null
    },
    modal: {
        show: false
    }
};
